export default __webpack_public_path__ + "static/media/rutgers-shield-logo-new.436fc289.svg";